/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiAppExceptionTestBrokerExceptionGet400Response } from '../model/api-app-exception-test-broker-exception-get400-response.model';
// @ts-ignore
import { ProductCallidusPipelineResultDto } from '../model/product-callidus-pipeline-result-dto.model';
// @ts-ignore
import { PublicCallidusOffertSparteUploadDto } from '../model/public-callidus-offert-sparte-upload-dto.model';
// @ts-ignore
import { PublicCallidusOffertUploadInfoDto } from '../model/public-callidus-offert-upload-info-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicCallidusOffertUploadApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/public-callidus-offert-upload/offert/{offertId}/info
     * @param offertId 
     * @param oneTimeAccessToken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusOffertUploadOffertOffertIdInfoGet(offertId: string, oneTimeAccessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PublicCallidusOffertUploadInfoDto>;
    public apiPublicCallidusOffertUploadOffertOffertIdInfoGet(offertId: string, oneTimeAccessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PublicCallidusOffertUploadInfoDto>>;
    public apiPublicCallidusOffertUploadOffertOffertIdInfoGet(offertId: string, oneTimeAccessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PublicCallidusOffertUploadInfoDto>>;
    public apiPublicCallidusOffertUploadOffertOffertIdInfoGet(offertId: string, oneTimeAccessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (offertId === null || offertId === undefined) {
            throw new Error('Required parameter offertId was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdInfoGet.');
        }
        if (oneTimeAccessToken === null || oneTimeAccessToken === undefined) {
            throw new Error('Required parameter oneTimeAccessToken was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdInfoGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>oneTimeAccessToken, 'oneTimeAccessToken');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-offert-upload/offert/${this.configuration.encodeParam({name: "offertId", value: offertId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/info`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PublicCallidusOffertUploadInfoDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-offert-upload/offert/{offertId}
     * @param offertId 
     * @param file 
     * @param sparten 
     * @param callidusContractId 
     * @param oneTimeAccessToken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusOffertUploadOffertOffertIdPost(offertId: string, file: Blob, sparten: Array<PublicCallidusOffertSparteUploadDto>, callidusContractId: string, oneTimeAccessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductCallidusPipelineResultDto>;
    public apiPublicCallidusOffertUploadOffertOffertIdPost(offertId: string, file: Blob, sparten: Array<PublicCallidusOffertSparteUploadDto>, callidusContractId: string, oneTimeAccessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusOffertUploadOffertOffertIdPost(offertId: string, file: Blob, sparten: Array<PublicCallidusOffertSparteUploadDto>, callidusContractId: string, oneTimeAccessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusOffertUploadOffertOffertIdPost(offertId: string, file: Blob, sparten: Array<PublicCallidusOffertSparteUploadDto>, callidusContractId: string, oneTimeAccessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (offertId === null || offertId === undefined) {
            throw new Error('Required parameter offertId was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdPost.');
        }
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdPost.');
        }
        if (sparten === null || sparten === undefined) {
            throw new Error('Required parameter sparten was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdPost.');
        }
        if (callidusContractId === null || callidusContractId === undefined) {
            throw new Error('Required parameter callidusContractId was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdPost.');
        }
        if (oneTimeAccessToken === null || oneTimeAccessToken === undefined) {
            throw new Error('Required parameter oneTimeAccessToken was null or undefined when calling apiPublicCallidusOffertUploadOffertOffertIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('File', <any>file) as any || localVarFormParams;
        }
        if (sparten) {
            sparten.forEach((element) => {
                localVarFormParams = localVarFormParams.append('Sparten', <any>element) as any || localVarFormParams;
            })
        }
        if (callidusContractId !== undefined) {
            localVarFormParams = localVarFormParams.append('CallidusContractId', <any>callidusContractId) as any || localVarFormParams;
        }
        if (oneTimeAccessToken !== undefined) {
            localVarFormParams = localVarFormParams.append('OneTimeAccessToken', <any>oneTimeAccessToken) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-offert-upload/offert/${this.configuration.encodeParam({name: "offertId", value: offertId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductCallidusPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
